import { render } from "./UpdateIva.vue?vue&type=template&id=b124b126"
import script from "./UpdateIva.vue?vue&type=script&lang=js"
export * from "./UpdateIva.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__